module.exports = dibs_vendor;


//////////////////
// WEBPACK FOOTER
// external "dibs_vendor"
// module id = 43
// module chunks = 63